import { sdkFactory as wixCaptcharatorV1CaptchaEntity_sdkFactory_captcha } from './src/captcharator-v1-captcha-entity.frontend';
export function sdkFactory(args) {
    return {
        captcha: wixCaptcharatorV1CaptchaEntity_sdkFactory_captcha(args),
    };
}
//# sourceMappingURL=index.frontend.js.map